const CHAINS = [
  {
    name: "Aevo",
    launchDate: "Jun 14, 2023",
    vertical: "DeFi",
    statsUrl: "https://explorer-aevo-mainnet-prod-0.t.conduit.xyz/api/v2/stats",
    raas: "Conduit",
    layer: 2,
    rollup: "Optimism",
    nativeToken: "ETH",
    settlementL3: "—",
    linesUrl:
      "https://explorer-aevo-mainnet-prod-0.t.conduit.xyz/api/v1/lines/newTxns",
  },
  {
    name: "AlienX",
    launchDate: "Jun 24, 2024",
    vertical: "Gaming",
    statsUrl: "https://api-explorer.alienxchain.io/api/v2/stats",
    raas: "Caldera",
    layer: 2,
    rollup: "Arbitrum",
    nativeToken: "ETH",
    settlementL3: "—",
    linesUrl: "https://api-explorer.alienxchain.io/stats/api/v1/lines/newTxns",
  },
  {
    name: "Ancient8 Mainnet",
    launchDate: "Feb 22, 2024",
    vertical: "Gaming",
    statsUrl: "https://explorer-ancient8-mainnet-0.t.conduit.xyz/api/v2/stats",
    raas: "Conduit",
    layer: 2,
    rollup: "Optimism",
    nativeToken: "ETH",
    settlementL3: "—",
    linesUrl:
      "https://explorer-ancient8-mainnet-0.t.conduit.xyz/api/v1/lines/newTxns",
  },
  {
    name: "AppChain Mainnet",
    launchDate: "—",
    vertical: "—",
    statsUrl: "https://appchain.calderaexplorer.xyz/api/v2/stats",
    raas: "Caldera",
    layer: 2,
    rollup: "Arbitrum",
    nativeToken: "ETH",
    settlementL3: "—",
    linesUrl: "https://appchain.calderaexplorer.xyz/stats/api/v1/lines/newTxns",
  },
  {
    name: "Arena-Z (Arenaz)",
    launchDate: "Sep 4, 2024",
    vertical: "Gaming",
    statsUrl: "https://explorer.arena-z.gg/api/v2/stats",
    raas: "Gelato",
    layer: 2,
    rollup: "Optimism",
    nativeToken: "ETH",
    settlementL3: "—",
    linesUrl: "https://stats-arena-z.cloud.blockscout.com/api/v1/lines/newTxns",
  },
  {
    name: "B3 Mainnet (DIA LaserNet)",
    launchDate: "Nov 26, 2024",
    vertical: "Infra",
    statsUrl: "https://b3.calderaexplorer.xyz/api/v2/stats",
    raas: "Caldera",
    layer: 3,
    rollup: "Optimism",
    nativeToken: "ETH",
    settlementL3: "Base",
    linesUrl: null,
  },
  {
    name: "Bitlazer",
    launchDate: "—",
    vertical: "—",
    statsUrl: "https://bitlazer.calderaexplorer.xyz/api/v2/stats",
    raas: "Caldera",
    layer: 3,
    rollup: "Arbitrum",
    nativeToken: "LZRBTC",
    settlementL3: "Arbitrum",
    linesUrl: "https://bitlazer.calderaexplorer.xyz/stats/api/v1/lines/newTxns",
  },
  {
    name: "Blessnet",
    launchDate: "—",
    vertical: "—",
    statsUrl: "https://blessnet.calderaexplorer.xyz/api/v2/stats",
    raas: "Caldera",
    layer: 2,
    rollup: "Arbitrum",
    nativeToken: "BLESS",
    settlementL3: "—",
    linesUrl: "https://blessnet.calderaexplorer.xyz/stats/api/v1/lines/newTxns",
  },
  {
    name: "Cheese Chain (Cheesechain)",
    launchDate: "May 1, 2024",
    vertical: "Ecosystem",
    statsUrl: "https://cheesechain.calderaexplorer.xyz/api/v2/stats",
    raas: "Caldera",
    layer: 3,
    rollup: "Arbitrum",
    nativeToken: "CHEESE",
    settlementL3: "Arbitrum",
    linesUrl:
      "https://cheesechain.calderaexplorer.xyz/stats/api/v1/lines/newTxns",
  },
  {
    name: "Clique",
    launchDate: "Mar 21, 2024",
    vertical: "Gaming",
    statsUrl: null,
    raas: "Conduit",
    layer: 3,
    rollup: "Optimism",
    nativeToken: "ETH",
    settlementL3: "Base",
    linesUrl: null,
  },
  {
    name: "Conwai Mainnet",
    launchDate: "Dec 11, 2024",
    vertical: "—",
    statsUrl: "https://conwai.calderaexplorer.xyz/api/v2/stats",
    raas: "Caldera",
    layer: 3,
    rollup: "Arbitrum",
    nativeToken: "CWT",
    settlementL3: "Arbitrum",
    linesUrl: "https://conwai.calderaexplorer.xyz/stats/api/v1/lines/newTxns",
  },
  {
    name: "Degen Chain",
    launchDate: "Dec 11, 2024",
    vertical: "DeFi",
    statsUrl: "https://explorer.degen.tips/api/v2/stats",
    raas: "Alchemy",
    layer: 3,
    rollup: "Arbitrum",
    nativeToken: "DEGEN",
    settlementL3: "Arbitrum",
    linesUrl:
      "https://stats-degen-mainnet.cloud.blockscout.com/api/v1/lines/newTxns",
  },
  {
    name: "Derive Mainnet",
    launchDate: "Dec 15, 2023",
    vertical: "DeFi",
    statsUrl: "https://explorer-lyra-mainnet-0.t.conduit.xyz/api/v2/stats",
    raas: "Conduit",
    layer: 2,
    rollup: "Optimism",
    nativeToken: "ETH",
    settlementL3: "—",
    linesUrl:
      "https://explorer-lyra-mainnet-0.t.conduit.xyz/api/v1/lines/newTxns",
  },
  {
    name: "DIA LaserNet Mainnet",
    launchDate: "Nov 26, 2024",
    vertical: "Infra",
    statsUrl:
      "https://explorer-dia-lasernet-mainnet-n208gs8dc3.t.conduit.xyz/api/v2/stats",
    raas: "Conduit",
    layer: 2,
    rollup: "Arbitrum",
    nativeToken: "DIA",
    settlementL3: "—",
    linesUrl:
      "https://explorer-dia-lasernet-mainnet-n208gs8dc3.t.conduit.xyz/api/v1/lines/newTxns",
  },
  {
    name: "Edgeless",
    launchDate: "Mar 28, 2024",
    vertical: "Ecosystem",
    statsUrl: "https://edgeless-mainnet.calderaexplorer.xyz/api/v2/stats",
    raas: "Caldera",
    layer: 2,
    rollup: "Arbitrum",
    nativeToken: "EWETH",
    settlementL3: "—",
    linesUrl:
      "https://edgeless-mainnet.calderaexplorer.xyz/stats/api/v1/lines/",
  },
  {
    name: "EDU Chain",
    launchDate: "Aug 29, 2024",
    vertical: "Social",
    statsUrl: "https://educhain.blockscout.com/api/v2/stats",
    raas: "Gelato",
    layer: 3,
    rollup: "Arbitrum",
    nativeToken: "EDU",
    settlementL3: "Arbitrum",
    linesUrl:
      "https://educhain.blockscout.com/stats-service/api/v1/lines/newTxns",
  },
  {
    name: "Fluence",
    launchDate: "Aug 20, 2024",
    vertical: "Infra",
    statsUrl: "https://blockscout.mainnet.fluence.dev/api/v2/stats",
    raas: "Gelato",
    layer: 2,
    rollup: "Arbitrum",
    nativeToken: "FLT",
    settlementL3: "—",
    linesUrl:
      "https://blockscout.mainnet.fluence.dev/stats-service/api/v1/lines/",
  },
  {
    name: "Ham",
    launchDate: "Jun 5, 2024",
    vertical: "Social",
    statsUrl: "https://ham.calderaexplorer.xyz/api/v2/stats",
    raas: "Caldera",
    layer: 3,
    rollup: "Optimism",
    nativeToken: "ETH",
    settlementL3: "Base",
    linesUrl: "https://ham.calderaexplorer.xyz/stats/api/v1/lines/",
  },
  {
    name: "Huddle01 Mainnet",
    launchDate: "Sep 23, 2024",
    vertical: "DeFi",
    statsUrl: "https://huddle01.calderaexplorer.xyz/api/v2/stats",
    raas: "Caldera",
    layer: 3,
    rollup: "Arbitrum",
    nativeToken: "ETH",
    settlementL3: "Arbitrum",
    linesUrl: "https://huddle01.calderaexplorer.xyz/stats/api/v1/lines",
  },
  {
    name: "Hychain",
    launchDate: "Mar 8, 2024",
    vertical: "Gaming",
    statsUrl: "https://hychain.calderaexplorer.xyz/api/v2/stats",
    raas: "Caldera",
    layer: 2,
    rollup: "Arbitrum",
    nativeToken: "TOPIA",
    settlementL3: "—",
    linesUrl: "https://hychain.calderaexplorer.xyz/stats/api/v1/lines/",
  },
  {
    name: "inEVM Mainnet",
    launchDate: "Apr 24, 2024",
    vertical: "Ecosystem",
    statsUrl: "https://inevm.calderaexplorer.xyz/api/v2/stats",
    raas: "Caldera",
    layer: 2,
    rollup: "Arbitrum",
    nativeToken: "INJ",
    settlementL3: "—",
    linesUrl: "https://inevm.calderaexplorer.xyz/stats/api/v1/lines/newTxns",
  },
  {
    name: "Ink",
    launchDate: "Oct 24, 2024",
    vertical: "DeFi",
    statsUrl: "https://explorer.inkonchain.com/api/v2/stats",
    raas: "Gelato",
    layer: 2,
    rollup: "Optimism",
    nativeToken: "ETH",
    settlementL3: "—",
    linesUrl: "https://explorer.inkonchain.com/stats-service/api/v1/lines",
  },
  {
    name: "K2",
    launchDate: "Jan 1, 2025",
    vertical: "Ecosystem",
    statsUrl: "https://karak.calderaexplorer.xyz/api/v2/stats",
    raas: "Caldera",
    layer: 2,
    rollup: "Optimism",
    nativeToken: "ETH",
    settlementL3: "—",
    linesUrl: "https://karak.calderaexplorer.xyz/stats/api/v1/lines/",
  },
  {
    name: "Lisk",
    launchDate: "Jun 1, 2024",
    vertical: "Ecosystem",
    statsUrl: "https://blockscout.lisk.com/api/v2/stats",
    raas: "Gelato",
    layer: 2,
    rollup: "Optimism",
    nativeToken: "ETH",
    settlementL3: "—",
    linesUrl: "https://blockscout.lisk.com/stats-service/api/v1/lines/",
  },
  {
    name: "Lumia Mainnet (Lumio)",
    launchDate: "Feb 28, 2024",
    vertical: "Ecosystem",
    statsUrl: "https://explorer.lumia.org/api/v2/stats",
    raas: "Conduit",
    layer: 2,
    rollup: "Optimism",
    nativeToken: "ETH",
    settlementL3: "—",
    linesUrl: "https://explorer.lumia.org/api/stats/api/v1/lines/",
  },
  {
    name: "Manta Pacific",
    launchDate: "Sep 12, 2023",
    vertical: "Ecosystem",
    statsUrl: "https://manta-pacific.calderaexplorer.xyz/api/v2/stats",
    raas: "Caldera",
    layer: 2,
    rollup: "Optimism",
    nativeToken: "ETH",
    settlementL3: "—",
    linesUrl: "https://manta-pacific.calderaexplorer.xyz/stats/api/v1/lines/",
  },
  {
    name: "Mode",
    launchDate: "Feb 1, 2024",
    vertical: "Ecosystem",
    statsUrl: "https://explorer-mode-mainnet-0.t.conduit.xyz/api/v2/stats",
    raas: "Conduit",
    layer: 2,
    rollup: "Optimism",
    nativeToken: "ETH",
    settlementL3: "—",
    linesUrl: "https://explorer-mode-mainnet-0.t.conduit.xyz/api/v1/lines/",
  },
  {
    name: "Molten",
    launchDate: "Apr 1, 2024",
    vertical: "DeFi",
    statsUrl: "https://molten.calderaexplorer.xyz/api/v2/stats",
    raas: "Caldera",
    layer: 2,
    rollup: "Arbitrum",
    nativeToken: "MOLTEN",
    settlementL3: "—",
    linesUrl: "https://molten.calderaexplorer.xyz/stats/api/v1/lines/",
  },
  {
    name: "Muster Network",
    launchDate: "Nov 7, 2023",
    vertical: "Gaming",
    statsUrl: "https://muster-explorer.alt.technology/api/v2/stats",
    raas: "AltLayer",
    layer: 3,
    rollup: "Optimism",
    nativeToken: "ETH",
    settlementL3: "Arbitrum",
    linesUrl: "https://muster-explorer.alt.technology/api/v1/lines/",
  },
  {
    name: "OEV Network",
    launchDate: "Jul 16, 2024",
    vertical: "DeFi",
    statsUrl: "https://oev-network.calderaexplorer.xyz/api/v2/stats",
    raas: "Caldera",
    layer: 2,
    rollup: "Arbitrum",
    nativeToken: "ETH",
    settlementL3: "—",
    linesUrl: "https://oev-network.calderaexplorer.xyz/stats/api/v1/lines",
  },
  {
    name: "OpenZK",
    launchDate: "—",
    vertical: "—",
    statsUrl: "https://explorer.openzk.net/api/v2/stats",
    raas: "Caldera",
    layer: 2,
    rollup: "ZK",
    nativeToken: "OZETH",
    settlementL3: "—",
    linesUrl: null,
  },
  {
    name: "Orderly",
    launchDate: "Jan 22, 2024",
    vertical: "DeFi",
    statsUrl: "https://explorer-orderly-mainnet-0.t.conduit.xyz/api/v2/stats",
    raas: "Conduit",
    layer: 2,
    rollup: "Optimism",
    nativeToken: "ETH",
    settlementL3: "—",
    linesUrl: "https://explorer-orderly-mainnet-0.t.conduit.xyz/api/v1/lines/",
  },
  {
    name: "Perennial Mainnet",
    launchDate: "—",
    vertical: "—",
    statsUrl:
      "https://explorer-perennial-lsv53i0ed8.t.conduit.xyz/api/v2/stats",
    raas: "Conduit",
    layer: 2,
    rollup: "Optimism",
    nativeToken: "ETH",
    settlementL3: "—",
    linesUrl:
      "https://explorer-perennial-lsv53i0ed8.t.conduit.xyz/api/v1/lines/",
  },
  {
    name: "Playnance Playblock",
    launchDate: "Mar 1, 2024",
    vertical: "Gaming",
    statsUrl: "https://explorer.playblock.io/api/v2/stats",
    raas: "Gelato",
    layer: 3,
    rollup: "Optimism",
    nativeToken: "PBG",
    settlementL3: "Arbitrum",
    linesUrl: "https://explorer.playblock.io/stats-service/api/v1/lines/",
  },
  {
    name: "Pontem Lumio",
    launchDate: "Feb 28, 2024",
    vertical: "Ecosystem",
    statsUrl: null,
    raas: "Conduit",
    layer: 2,
    rollup: "Optimism",
    nativeToken: "ETH",
    settlementL3: "—",
    linesUrl: null,
  },
  {
    name: "Prom Mainnet",
    launchDate: "Mar 16, 2024",
    vertical: "DeFi",
    statsUrl: "https://promscan.io/api/v2/stats",
    raas: "—",
    layer: 2,
    rollup: "Optimism",
    nativeToken: "PROM",
    settlementL3: "—",
    linesUrl: "https://promscan.io/api/stats/api/v1/lines/",
  },
  {
    name: "Proof of Play",
    launchDate: "Feb 22, 2024",
    vertical: "Gaming",
    statsUrl:
      "https://explorer-proofofplay-boss-mainnet.t.conduit.xyz/api/v2/stats",
    raas: "Conduit",
    layer: 2,
    rollup: "Arbitrum",
    nativeToken: "ETH",
    settlementL3: "—",
    linesUrl:
      "https://explorer-proofofplay-boss-mainnet.t.conduit.xyz/api/v1/lines/",
  },
  {
    name: "Proof of Play Apex",
    launchDate: "—",
    vertical: "—",
    statsUrl:
      "https://explorer-proofofplay-apex-mainnet-0.t.conduit.xyz/api/v2/stats",
    raas: "Conduit",
    layer: 2,
    rollup: "Optimism",
    nativeToken: "ETH",
    settlementL3: "—",
    linesUrl:
      "https://explorer-proofofplay-apex-mainnet-0.t.conduit.xyz/api/v1/lines/",
  },
  {
    name: "RARI Chain",
    launchDate: "Jan 24, 2024",
    vertical: "NFT",
    statsUrl: "https://rari.calderaexplorer.xyz/api/v2/stats",
    raas: "Caldera",
    layer: 3,
    rollup: "Arbitrum",
    nativeToken: "ETH",
    settlementL3: "Arbitrum",
    linesUrl: "https://rari.calderaexplorer.xyz/stats/api/v1/lines/",
  },
  {
    name: "Reya",
    launchDate: "Apr 1, 2024",
    vertical: "DeFi",
    statsUrl: "https://explorer.reya.network/api/v2/stats",
    raas: "Gelato",
    layer: 2,
    rollup: "Optimism",
    nativeToken: "ETH",
    settlementL3: "—",
    linesUrl: "https://explorer.reya.network/stats-service/api/v1/lines/",
  },
  {
    name: "Rivalz",
    launchDate: "Aug 20, 2024",
    vertical: "AI",
    statsUrl: "https://rivalz.calderaexplorer.xyz/api/v2/stats",
    raas: "Caldera",
    layer: 2,
    rollup: "Arbitrum",
    nativeToken: "ETH",
    settlementL3: "—",
    linesUrl: "https://rivalz.calderaexplorer.xyz/stats/api/v1/lines/",
  },
  {
    name: "Rufus",
    launchDate: "—",
    vertical: "—",
    statsUrl: "https://rufus.calderaexplorer.xyz/api/v2/stats",
    raas: "Caldera",
    layer: 2,
    rollup: "Arbitrum",
    nativeToken: "ELON",
    settlementL3: "—",
    linesUrl: "https://rufus.calderaexplorer.xyz/stats/api/v1/lines/",
  },
  {
    name: "Sanko Nitro Mainnet",
    launchDate: "May 19, 2024",
    vertical: "Gaming",
    statsUrl: "https://sanko-mainnet.calderaexplorer.xyz/api/v2/stats",
    raas: "Caldera",
    layer: 3,
    rollup: "Arbitrum",
    nativeToken: "DMT",
    settlementL3: "Arbitrum",
    linesUrl: "https://sanko-mainnet.calderaexplorer.xyz/stats/api/v1/lines/",
  },
  {
    name: "Shape",
    launchDate: "Sep 30, 2024",
    vertical: "—",
    statsUrl: "https://shapescan.xyz/api/v2/stats",
    raas: "Alchemy",
    layer: 2,
    rollup: "Optimism",
    nativeToken: "ETH",
    settlementL3: "—",
    linesUrl: "https://shapescan.xyz/stats-service/api/v1/lines/",
  },
  {
    name: "SnaxChain Mainnet",
    launchDate: "Sep 15, 2024",
    vertical: "DeFi",
    statsUrl: null,
    raas: "Conduit",
    layer: 2,
    rollup: "Optimism",
    nativeToken: "ETH",
    settlementL3: "—",
    linesUrl: null,
  },
  {
    name: "Swell Chain",
    launchDate: "Mar 13, 2024",
    vertical: "Ecosystem",
    statsUrl: "https://explorer.swellnetwork.io/api/v2/stats",
    raas: "AltLayer",
    layer: 2,
    rollup: "ZK",
    nativeToken: "ETH",
    settlementL3: "—",
    linesUrl: "https://explorer.swellnetwork.io/api/v1/lines/",
  },
  {
    name: "Symbiosis",
    launchDate: "—",
    vertical: "—",
    statsUrl: "https://symbiosis.calderaexplorer.xyz/api/v2/stats",
    raas: "Caldera",
    layer: 2,
    rollup: "Arbitrum",
    nativeToken: "SIS",
    settlementL3: "—",
    linesUrl: "https://symbiosis.calderaexplorer.xyz/stats/api/v1/lines/",
  },
  {
    name: "Syndicate Frame",
    launchDate: "Feb 15, 2024",
    vertical: "Social",
    statsUrl: "https://syndicate-frame.calderaexplorer.xyz/api/v2/stats",
    raas: "Caldera",
    layer: 3,
    rollup: "Optimism",
    nativeToken: "ETH",
    settlementL3: "Base",
    linesUrl: "https://syndicate-frame.calderaexplorer.xyz/stats/api/v1/lines/",
  },
  {
    name: "Towns Mainnet",
    launchDate: "—",
    vertical: "—",
    statsUrl: "https://towns-mainnet.calderaexplorer.xyz/api/v2/stats",
    raas: "Caldera",
    layer: 2,
    rollup: "Optimism",
    nativeToken: "ETH",
    settlementL3: "—",
    linesUrl: "https://towns-mainnet.calderaexplorer.xyz/stats/api/v1/lines/",
  },
  {
    name: "TRUMPCHAIN",
    launchDate: "—",
    vertical: "—",
    statsUrl: null,
    raas: "Caldera",
    layer: 2,
    rollup: "Arbitrum",
    nativeToken: "TRUMP",
    settlementL3: "—",
    linesUrl: null,
  },
  {
    name: "VEMP Horizon",
    launchDate: "—",
    vertical: "—",
    statsUrl: "https://vemp-horizon.calderaexplorer.xyz/api/v2/stats",
    raas: "Caldera",
    layer: 3,
    rollup: "Arbitrum",
    nativeToken: "VEMP",
    settlementL3: "Arbitrum",
    linesUrl: "https://vemp-horizon.calderaexplorer.xyz/stats/api/v1/lines/",
  },
  {
    name: "World Chain",
    launchDate: "Jun 26, 2024",
    vertical: "Ecosystem",
    statsUrl: "https://worldchain-mainnet.explorer.alchemy.com/api/v2/stats",
    raas: "Alchemy",
    layer: 2,
    rollup: "Optimism",
    nativeToken: "ETH",
    settlementL3: "—",
    linesUrl:
      "https://worldchain-mainnet.explorer.alchemy.com/stats-service/api/v1/lines/",
  },
  {
    name: "XR1",
    launchDate: "—",
    vertical: "Gaming",
    statsUrl: "https://xr1.calderaexplorer.xyz/api/v2/stats",
    raas: "Caldera",
    layer: 3,
    rollup: "Arbitrum",
    nativeToken: "XR1",
    settlementL3: "Arbitrum",
    linesUrl: "https://xr1.calderaexplorer.xyz/stats/api/v1/lines/",
  },
  {
    name: "ZERϴ Network",
    launchDate: "Nov 12, 2024",
    vertical: "Ecosystem",
    statsUrl: null,
    raas: "Caldera",
    layer: 2,
    rollup: "ZK",
    nativeToken: "ETH",
    settlementL3: "—",
    linesUrl: null,
  },
];

export default CHAINS;
